import { IconModel, LocalizedValueModel } from '..';
import { VisibilityEnum } from '../enums/visibility.enum';

export class DuplicatedCollectionPresenterModel {
  constructor(
    name: LocalizedValueModel,
    icon: IconModel,
    visibility: VisibilityEnum,
    module: string,
    dataEntity: string,
    description?: LocalizedValueModel,
    specificationVersion?: number,
  ) {
    this.name = name;
    this.description = description;
    this.specificationVersion = specificationVersion;
    this.icon = icon;
    this.visibility = visibility;
    this.dataEntity = dataEntity;
    this.module = module;
  }

  id?: string;
  name: LocalizedValueModel;
  description?: LocalizedValueModel;
  specificationVersion?: number;
  icon: IconModel;
  visibility: VisibilityEnum;
  module: string;
  dataEntity: string;
}
